import { noop } from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { RefObject, useLayoutEffect } from 'react';

/**
 * 监听元素的大小更改
 * @param effect
 * @param targetRef
 */
export function useResizeEffect(effect: () => void, targetRef: RefObject<HTMLElement>) {
  const fn = hooks.useCallbackRef(effect);
  useLayoutEffect(() => {
    const target = targetRef.current;
    if (target) {
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(() => {
          fn();
        });
        observer.observe(target);
        return () => {
          observer.disconnect();
        };
      } else {
        fn();
      }
    }
    return noop;
  }, [fn, targetRef]);
}
